import s3 from './s3';

export const getSignedUrl = (key, contentType) =>
  s3.getSignedUrl('getObject', {
    Bucket: process.env.REACT_APP_BUCKET,
    Key: key,
    Expires: Number(process.env.REACT_APP_SIGNED_URL_TIME),
    ResponseContentType: contentType,
  });
